export const BOX_BOOKING_SET_ARIVIAL_DATE = 'BOX_BOOKING_SET_ARIVIAL_DATE';
export const BOX_BOOKING_TOGGLE_CONTRACT_ACCEPT = 'BOX_BOOKING_TOGGLE_CONTRACT_ACCEPT';
export const BOX_BOOKING_SET_ERROR = 'BOX_BOOKING_SET_ERROR';
export const BOX_BOOKING_DEL_ERROR = 'BOX_BOOKING_DEL_ERROR';
export const IQACDOCUMENT_SET_DATA = 'IQACDOCUMENT_SET_DATA';